import { View, Text, Image, TouchableOpacity, YellowBox } from 'react-native';
import { useState , useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useWindowDimensions } from '../hooks/useWindowDimensions';
import { mainSite } from '../config.js';
import styled from 'styled-components/native';
import {
  WorkoutContainerText,
  WorkoutCommonButton,
} from '../styles/common-styles.js';

// Ignore the specific warning about the error
YellowBox.ignoreWarnings(['Setting a timer']);

function WorkoutIntroduction({ navigation }) {
  
  const { width } = useWindowDimensions();
  const { current_workout_activity, current_workout } = useSelector((state) => state.cbcWorkout);
  const [parentWidth, setParentWidth] = useState(null);
  const [activeContainer, setActiveContainer] = useState(null);
  const onNextButtonClick = () => {
    setActiveContainer('showWarmup');
  };

  useEffect(() => {
    if(current_workout.workout_sequence_number === "1"){
      setActiveContainer('showIntroduction');
    } else {
      setActiveContainer('showWarmup');
    }
  }, [current_workout]);

  const onLayout = (event) => {
    const { width } = event.nativeEvent.layout;
    ////console.log(event.nativeEvent.layout);
    setParentWidth(width);
  };

  const dispatch = useDispatch();
  const {userId} = useSelector((state) => state.cbcAuthorization); 

  // Ensure all necessary state is available before rendering
  if (parentWidth === null || activeContainer === null) {
    return <View onLayout={onLayout} />;
  }

  return (
    <WorkoutPopupParent>
      {activeContainer === 'showIntroduction' && (
        <WorkoutPopupContainer
          onLayout={(event) => {
            const { width } = event.nativeEvent.layout;
            ////console.log('Width from onLayout:', width);  // debug log
            setParentWidth(width);
          }}
        >
          <WorkoutPopupHeaderBorderTop
            width={parentWidth}
            source={{
              uri: `${mainSite}/wp-content/plugins/advanced-healthcare-solutions/media/Cerebrocore_on-your-mark-border (1).png`,
            }}
          />
          <WorkoutPopupHeaderImg
            width={parentWidth}
            source={{
              uri: `${mainSite}/wp-content/plugins/advanced-healthcare-solutions/media/Cerebrocore_on-your-mark-text.png`,
            }}
          />
          <WorkoutPopupHeaderText>Welcome to the Starting Line</WorkoutPopupHeaderText>
          <WorkoutContainerText>
            Your training begins with a series of exercises to evaluate your brain's performance. We'll be evaluating
            six memory categories, visual memory, auditory memory, concentration, pattern recognition, and tracking.
          </WorkoutContainerText>
          <WorkoutCommonButton style={{marginTop:15}} onPress={onNextButtonClick}>
            <Text style={{ color: 'white', fontWeight: '500' }}>NEXT</Text>
          </WorkoutCommonButton>
          <WorkoutPopupHeaderBorderBottom
            width={parentWidth}
            source={{
              uri: `${mainSite}/wp-content/plugins/advanced-healthcare-solutions/media/Cerebrocore_dashboard-tour-border (1).png`,
            }}
            resizeMode="stretch"
          />
        </WorkoutPopupContainer>
      )}

      {activeContainer === 'showWarmup' && (
        <WorkoutPopupContainer
        onLayout={(event) => {
          const { width } = event.nativeEvent.layout;
          ////console.log('Width from onLayout:', width);  // debug log
          setParentWidth(width);
        }}
        >
          <WorkoutPopupHeaderBorderTop
            width={parentWidth}
            source={{
              uri: `${mainSite}/wp-content/plugins/advanced-healthcare-solutions/media/Cerebrocore_focused-breathing-border (1).png`,
            }}
            resizeMode="stretch"
          />
          <WorkoutPopupHeaderImg
            width={parentWidth}
            source={{
              uri: `${mainSite}/wp-content/plugins/advanced-healthcare-solutions/media/Cerebrocore_warmup-text.png`,
            }}
            style={{ maxHeight: 30, maxWidth: 200 }}
            resizeMode="stretch"
          />
          <WorkoutPopupHeaderText>Focused Breathing</WorkoutPopupHeaderText>
          <WorkoutContainerText>
            It's time to stretch! Before each workout, we'll guide you through two minutes of Focused Breathing, which
            is a series of breathing exercises combined with specific audio tones. Why? It readies your brain, calling
            it to attention to get ready for your workout.
          </WorkoutContainerText>
          <WorkoutCommonButton
            style={{marginTop:15}}
            onPress={() => navigation.navigate('activitycontainer', { activityName: current_workout_activity.shortcode , activityId: current_workout_activity.id, userId: userId, gameType: 0, workoutId: current_workout.id })}
          >
            <Text style={{ color: 'white', fontWeight: '500' }}>NEXT</Text>
          </WorkoutCommonButton>
          <WorkoutPopupHeaderBorderBottom
            width={parentWidth}
            source={{
              uri: `${mainSite}/wp-content/plugins/advanced-healthcare-solutions/media/Cerebrocore_dashboard-tour-border (1).png`,
            }}
            resizeMode="stretch"
          />
        </WorkoutPopupContainer>
      )}
    </WorkoutPopupParent>
  );
}

const WorkoutPopupParent = styled.View`
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  flex: 1;

`;

const WorkoutPopupContainer = styled.View`
  height: auto;
  width: 100%;
  max-width: 450px;
  padding-left: 25px;
  padding-right: 25px;
  padding-bottom: 35px;
  background: #f8f9fb;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  position:relative;
`;

const WorkoutPopupHeaderBorderTop = styled.Image`
  height: 95px;
  position: absolute;
  width: ${(props) => props.width}px;
  top: -60px;
  left: 0;
  right: 0;
  resizeMode: stretch;
`;

const WorkoutPopupHeaderBorderBottom = styled.Image`
  height: 7px;
  position: absolute;
  bottom: -7px;
  left: 0;
  right: 0;
  width: ${(props) => props.width > 0 ? `${props.width}px` : '0'};
  resizeMode: stretch;
`;

const WorkoutPopupHeaderImg = styled.Image`
  height: 50px;
  width: 100%;
  margin-bottom: 15px;
  margin-top: 50px;
  resizeMode: stretch;
  max-width: 300px;
`;

const WorkoutPopupHeaderText = styled.Text`
  color: #3366cc;
  transform: scale(1, 1.15);
  font-weight: 600;
  font-size: 21px;
  margin-bottom: 5px;
`;

const WorkoutPopupBodyText = styled.Text`
  font-size: 18px;
  font-weight: 500;
  color: #38406f;
  line-height: 1.5;
  margin-bottom: 15px;
`;

export default WorkoutIntroduction;
